export enum MODAL_ACTION {
    CREATE,
    EDIT,
    DELETE,
    ADD,
    REMOVE,
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/modal-action.ts